<div class="flex flex-row space-x-8">
  <!-- Spinner enquanto carrega -->
  <ng-container *ngIf="loading$ | async; else charts">
    <div class="w-full flex justify-center p-8">
      <mat-spinner></mat-spinner>
    </div>
  </ng-container>

  <ng-template #charts>
    <!-- Instalações -->
    <div class="flex flex-col p-4 bg-white shadow-sm rounded w-1/2">
      <div class="flex justify-between items-center mb-2">
        <span class="text-xl font-bold">Instalações</span>
        <button mat-icon-button matTooltip="Acompanhar evolução" color="primary"
                routerLink="mobile/installation">
          <mat-icon svgIcon="heroicons_outline:presentation-chart-line"></mat-icon>
        </button>
      </div>

      <apx-chart
        *ngIf="chartOptions$ | async as opts"
        class="w-full h-full"
        [series]="opts.series"
        [chart]="opts.chart"
        [labels]="opts.labels"
        [legend]="opts.legend"
        [plotOptions]="opts.plotOptions"
        [colors]="opts.colors">
      </apx-chart>
    </div>

    <!-- Usuários Ativos Mensais -->
    <div class="flex flex-col p-4 bg-white shadow-sm rounded w-1/2">
      <div class="flex justify-between items-center mb-2">
        <span class="text-xl font-bold">Usuários Ativos Mensais</span>
        <button mat-icon-button matTooltip="Acompanhar evolução" color="primary"
                routerLink="mobile/mau">
          <mat-icon svgIcon="heroicons_outline:presentation-chart-line"></mat-icon>
        </button>
      </div>

      <apx-chart
        *ngIf="monthlyActiveUsersChartOptions$ | async as mauOpts"
        class="w-full h-full"
        [series]="mauOpts.series"
        [chart]="mauOpts.chart"
        [labels]="mauOpts.labels"
        [legend]="mauOpts.legend"
        [plotOptions]="mauOpts.plotOptions"
        [colors]="mauOpts.colors">
      </apx-chart>
    </div>
  </ng-template>
</div>
